import DrawerMain from './components/DrawerMain';
import { DrawerProvider } from './contexts/DrawerContext';

const Drawer = () => {
  return (<DrawerProvider>
    <DrawerMain></DrawerMain>
  </DrawerProvider>);
};
export default Drawer;
